import * as Yup from "yup";

export const careerValidationSchema = Yup.object().shape({
  title: Yup.string().required("Job Title is required"),
  location: Yup.string().required("Location is required"),
  description: Yup.string().required("Description is required"),
});

export const teamMemberSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email"),
  bio: Yup.string(),
  department_uid: Yup.string().required("Department is required"),
  seq_no: Yup.number()
    .typeError("Sequence must be a number")
    .required("Sequence number is required")
    .min(1, "Sequence number must be at least 1")
    .integer("Sequence number must be a whole number"),
  profile: Yup.string().required("Profile image is required"),
});

export const departmentSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  seq_no: Yup.number()
    .typeError("Sequence must be a number")
    .required("Sequence number is required")
    .min(1, "Sequence number must be at least 1")
    .integer("Sequence number must be a whole number"),
});

export const investorSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  email: Yup.string().email("Invalid email"),
  investor_type: Yup.string(),
  extra: Yup.string(),
  seq_no: Yup.number()
    .typeError("Sequence must be a number")
    .required("Sequence number is required")
    .min(1, "Sequence number must be at least 1")
    .integer("Sequence number must be a whole number"),
  profile: Yup.string().required("Profile image is required"),
  company_name: Yup.string(),
});
